// routes
import { paths } from 'src/routes/paths';
// utils
import axios from 'src/utils/axios';

// ----------------------------------------------------------------------

export function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

// One timer for whichever token is current: switching sessions (e.g. returning
// from "view as student", #605) must not leave the previous token's timer to
// sign the restored session out.
let expiredTimer;

export const tokenExpired = (exp) => {
  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    // alert('Token expired');

    // sessionStorage.removeItem('accessToken');
    localStorage.removeItem('accessToken');

    window.location.href = paths.auth.jwt.login;
  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken) => {
  if (accessToken) {
    // sessionStorage.setItem('accessToken', accessToken);
    // store to local storage
    localStorage.setItem('accessToken', accessToken);

    axios.defaults.headers.common.Token = `Bearer ${accessToken}`;
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
    tokenExpired(exp);
  } else {
    // sessionStorage.removeItem('accessToken');
    localStorage.removeItem('accessToken');

    clearTimeout(expiredTimer);
    delete axios.defaults.headers.common.Authorization;
  }
};

export const setDeviceSession = (token) => {
  if (token) {
    localStorage.setItem('device-token', token);
    // localStorage.setItem('device-name', name);
    // localStorage.setItem('device-id', deviceId);
    axios.defaults.headers.common.Token = `Bearer ${token}`;
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(token); // ~3 days by minimals server
    tokenExpired(exp);
  } else {
    // sessionStorage.removeItem('accessToken');
    localStorage.removeItem('device-token');
    localStorage.removeItem('device-name');
    localStorage.removeItem('device-id');
    delete axios.defaults.headers.common.Authorization;
  }
};
